import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-50f7d750"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "card"
};
const _hoisted_2 = {
  class: "card-title"
};
const _hoisted_3 = {
  key: 0
};
export default /*#__PURE__*/_defineComponent({
  __name: 'ModuleCard',
  props: {
    title: {
      type: String
    }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [__props.title ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.title), 1)) : _renderSlot(_ctx.$slots, "title", {
        key: 1
      }), _renderSlot(_ctx.$slots, "title-right", {
        style: "font-size: 12px"
      })]), _createElementVNode("div", null, [_renderSlot(_ctx.$slots, "default")])]);
    };
  }
});